import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","items":_vm.weightUnits,"label":_vm.$t('Weight Unit'),"hide-details":"auto"},model:{value:(_vm.weightUnit),callback:function ($$v) {_vm.weightUnit=$$v},expression:"weightUnit"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }